import { useState, useEffect } from "react";
import { Radar, Check } from "lucide-react";

const STEPS = [
  "Fetching profile signals",
  "Checking name & categories",
  "Auditing NAP consistency",
  "Scanning reviews & responses",
  "Analyzing posts & photos",
  "Compiling recommendations",
];

export const ScanningLoader = ({ businessName }) => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setActive((a) => (a < STEPS.length - 1 ? a + 1 : a));
    }, 14000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-background/95 backdrop-blur-sm px-4"
      data-testid="scanning-loader"
    >
      <div className="w-full max-w-xl">
        <div className="flex items-center gap-3 mb-8">
          <Radar className="h-6 w-6 text-brand animate-spin" style={{ animationDuration: "3s" }} />
          <span className="font-heading uppercase tracking-widest text-sm text-zinc-400">
            Auditing {businessName || "your profile"}
          </span>
        </div>

        {/* Wireframe of a GBP with scanning laser */}
        <div className="relative overflow-hidden border-2 border-zinc-600 bg-zinc-900 p-6">
          <div className="scanline" />
          <div className="h-6 w-1/2 bg-zinc-600 mb-4" />
          <div className="flex gap-2 mb-4">
            <div className="h-4 w-20 bg-zinc-700" />
            <div className="h-4 w-16 bg-zinc-700" />
            <div className="h-4 w-24 bg-zinc-700" />
          </div>
          <div className="grid grid-cols-4 gap-2 mb-4">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="aspect-square bg-zinc-700" />
            ))}
          </div>
          <div className="space-y-2">
            <div className="h-3 w-full bg-zinc-700" />
            <div className="h-3 w-4/5 bg-zinc-700" />
            <div className="h-3 w-2/3 bg-zinc-700" />
          </div>
        </div>

        <div className="mt-8 space-y-2.5">
          {STEPS.map((s, i) => {
            const done = i < active;
            const current = i === active;
            return (
              <div
                key={s}
                className={`flex items-center gap-3 font-body text-sm transition-colors duration-300 ${
                  done ? "text-zinc-500" : current ? "text-white" : "text-zinc-700"
                }`}
              >
                {done ? (
                  <Check className="h-4 w-4 text-pass shrink-0" />
                ) : current ? (
                  <span className="h-2 w-2 bg-brand animate-pulse shrink-0" />
                ) : (
                  <span className="h-2 w-2 bg-zinc-700 shrink-0" />
                )}
                {s}
              </div>
            );
          })}
        </div>
        <p className="mt-6 font-body text-xs text-zinc-600">
          This takes about a minute — we're pulling your listing apart the way a competitor would.
        </p>
      </div>
    </div>
  );
};

export default ScanningLoader;
